// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Marioworld Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const MarioWorldAliensPlanets = {
  planets: {
    1000: ['toad', 'goomba', 'koopa'], // Mushroom Kingdom
    1001: ['goomba', 'koopa'], // Grass Land
    1002: ['koopa', 'hammerbro'], // Desert Land
    1003: ['cheepcheep'], // Water Land
    1004: ['boo'], // Giant Land
    1005: ['lakitu'], // Sky Land
    1006: ['piranhaplant'], // Pipe Land
    1007: ['bowser', 'koopa', 'goomba', 'hammerbro'], // Dark Land
    1008: ['yoshi'], // Dinosaur Land
    1009: ['toad', 'peach'], // Peach's Castle
    999: ['bowser', 'boo'] // Black Hole (dark entities)
  },
  randomEncounters: ['goomba', 'koopa'],
  hostileSpecies: ['goomba', 'koopa', 'bowser', 'hammerbro', 'piranhaplant', 'boo'],
  friendlyTraders: ['toad', 'yoshi']
};

export default MarioWorldAliensPlanets;
